import { useIsDarkMode } from '@unistocks/shared/hooks/use-active-color-scheme';
import { AssetImageOptions, getAssetImage } from '@unistocks/shared/utils/asset-utils';
import { Asset } from '@unistocks/types/asset';
import { ImageSourcePropType } from 'react-native';

export const useAssetImage = (
  asset?: Asset,
  options?: AssetImageOptions
): ImageSourcePropType | null => {
  const isDarkMode = useIsDarkMode();

  if (!asset) {
    return null;
  }

  return getAssetImage(asset, isDarkMode, options);
};
